import axios from 'axios';
import _find from 'lodash/find';
import { auth } from '../utils/requests';
import { request_mutations, request_state } from '../utils/store';
import { FLOW_LIST, FLOW_DETAIL } from '../api';

export default {
    namespaced: true,
    state: {
        list: request_state(),
        create: request_state(),
        update: request_state(),
        detail: request_state(),
        remove: request_state(),
    },
    mutations: {
        ...request_mutations('list', 'list'),
        ...request_mutations('detail', 'detail'),
        ...request_mutations('create', 'create'),
        ...request_mutations('update', 'update'),
        ...request_mutations('remove', 'remove'),
    },
    actions: {
        list({ commit }, { space_id }) {
            const url = FLOW_LIST.replace('{space_id}', space_id);

            commit('list_loading');
            axios.get(url, auth()).then((response) => {
                commit('list_success', response.data);
            }).catch((error) => {
                commit('list_error', error.response ? error.response.data : {});
            });
        },
        create({ commit }, { space_id, data }) {
            const url = FLOW_LIST.replace('{space_id}', space_id);

            commit('create_loading');
            return new Promise((resolve) => {
                axios.post(url, data, auth()).then((response) => {
                    commit('create_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('create_error', error.response ? error.response.data : {});
                });
            });
        },
        detail({ commit }, { space_id, flow_id }) {
            const url = FLOW_DETAIL
                .replace('{space_id}', space_id)
                .replace('{flow_id}', flow_id);

            commit('detail_loading');
            return new Promise((resolve) => {
                axios.get(url, auth()).then((response) => {
                    commit('detail_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('detail_error', error.response ? error.response.data : {});
                });
            });
        },
        update({ commit }, { space_id, flow_id, data }) {
            const url = FLOW_DETAIL
                .replace('{space_id}', space_id)
                .replace('{flow_id}', flow_id);

            commit('update_loading');
            axios.patch(url, data, auth()).then((response) => {
                commit('update_success', response.data);
            }).catch((error) => {
                commit('update_error', error.response ? error.response.data : {});
            });
        },
        remove({ commit }, { space_id, flow_id }) {
            const url = FLOW_DETAIL
                .replace('{space_id}', space_id)
                .replace('{flow_id}', flow_id);

            commit('remove_loading');
            return new Promise((resolve) => {
                axios.delete(url, auth()).then((response) => {
                    commit('remove_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('remove_error', error.response ? error.response.data : {});
                });
            });
        },
    },
    getters: {
        by_id: state => id => _find(state.list.data.results, { id }),
    },
};
